import { AutoAwesomeMosaic } from '@mui/icons-material';
import { FormHelperText, Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { ModalProps } from 'src/hooks';

import { WidgetsCommonProps } from '../widget.interface';
import {
  Container,
  Image,
  InputTextLabel,
  StyledFileName,
  UploadImage,
} from './UploadFileWidget.styled';

export const UploadFileWidget = forwardRef(
  (
    props: WidgetsCommonProps & {
      assetUploadModal?: ModalProps;
      index?: number;
      onSelectIndex?: (index: number | null) => void;
    },
    ref,
  ) => {
    const handleClick = () => {
      if (props.onSelectIndex && props.index !== undefined) {
        props.onSelectIndex(props.index);
      }
      props.assetUploadModal?.onOpenModal();
    };

    return (
      <Container>
        <InputTextLabel>{props.label}</InputTextLabel>
        <UploadImage
          ref={ref}
          onClick={handleClick}
          component="label"
          variant="text"
          disabled={props.disabled}
          $hasError={props.hasError}
          $borderColor={props.options?.imageBorderColor}
          {...(props.options?.imageStyle?.height && {
            height: props.options.imageStyle.height,
          })}
          {...(props.options?.imageStyle?.width && {
            width: props.options.imageStyle.width,
          })}>
          {!props.value && (
            <Stack alignItems="center" padding="10px" gap="5px">
              <AutoAwesomeMosaic />
              <Typography
                sx={props.options?.hintStyle}
                color={props.disabled ? 'secondary.light' : 'secondary.dark'}>
                {props?.options?.hint}
              </Typography>
            </Stack>
          )}
          {props.value && (
            <Image
              src={props.value}
              alt="preview asset"
              {...(props.options?.imageStyle?.height && {
                height: props.options.imageStyle.height,
              })}
              {...(props.options?.imageStyle?.width && {
                width: props.options.imageStyle.width,
              })}
            />
          )}
        </UploadImage>

        {props.name && <StyledFileName>{props.name}</StyledFileName>}

        <FormHelperText error={Boolean(props.error)}>
          {props.error}
        </FormHelperText>
      </Container>
    );
  },
);
